import { useUIStore } from "@/shared/stores/ui-store";
import { useEffect } from "react";

export function useUnsavedChangesWarning() {
  const hasUnsavedChanges = useUIStore((state) => state.hasUnsavedChanges);

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = "";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [hasUnsavedChanges]);
}
